import React from 'react'
import Detay from './Detay'

const SeniorDetay = () => {
  return (
    <div>
        <Detay page="seniorDetay"/>
    </div>
  )
}

export default SeniorDetay